import { useState } from "react";
import axiosInstance from ".";
import { ApiResponseType } from "./type";
export type categoryType = {
  id: string;
  name: string;
  default: boolean;
  isActive: boolean;
  createdAt: string;
};

export type catgoryApiReturnType = {
  categories: categoryType[];
  getAllCategories: (filters: any, loadMore: boolean, id?: string) => Promise<ApiResponseType>;
  changeUserStatus: (userId: string, status: string) => Promise<ApiResponseType>;
  loading: boolean;
  totalPages: number;
  hasMore: boolean;
  setHasMore: any;
};
const useCatergoryApi = () => {
  const [categories, setCategories] = useState<any[]>([]);

  //need to declare seprate loading, pages, and hasMore for staff users
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const getAllCategories = async (filters: any, loadMore: boolean, id?: string) => {
    try {
      //will return in future
      // if (!loadMore) {
      //   setUsers([]);
      // }
      setLoading(true);
      let url = "category?";
      if (filters) {
        Object.entries(filters || {}).forEach(([key, value]) => {
          if (key && value) {
            url += `&${key}=${value}`;
          }
        });
      }
      const response = await axiosInstance.get(url);
      setTotalPages(response.data.result?.totalPages);
      if (loadMore) {
       
          setCategories((prev) => [...prev, ...response.data.result?.data]);
      } else {
        setCategories((prev) => [...prev, ...response.data.result?.data]);
      }
      if (filters.page >= response.data.result?.totalPages) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
      return {
        success: response.data.status === 201,
        data: response.data.result,
        message: response.data.message,
      };
    } catch (err: any) {
      return {
        success: false,
        data: err,
        message: err.response?.data?.message || "Something went wrong. Please try again",
      };
    } finally {
      setLoading(false);
    }
  };
  const changeUserStatus = async (userId: string, status: string) => {
    try {
      const response = await axiosInstance.patch(`user/${status}?id=${userId}`);
      return {
        success: response.data.status === 201,
        data: response.data.result,
        message: response.data.message,
      };
    } catch (err: any) {
      return {
        success: false,
        data: err,
        message: err.response?.data?.message || "Something went wrong. Please try again",
      };
    }
  };
  return {
    getAllCategories,
    totalPages,
    changeUserStatus,
    hasMore,
    setHasMore,
    loading,
  };
};

export default useCatergoryApi;
